<template>
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="24" height="24" viewBox="0 0 1000 1000" xml:space="preserve">
    <rect x="0" y="0" width="100%" height="100%" fill="rgba(255,255,255,0)" />
    <g transform="matrix(7.6923 0 0 7.6923 499.9995 499.9995)" id="75458">
      <path
        style="stroke: currentColor; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; is-custom-font: none; font-file-url: none; fill: currentColor; fill-rule: nonzero; opacity: 1;"
        vector-effect="non-scaling-stroke" transform=" translate(-67.5, -67.5)"
        d="M 132.5 67.5 C 132.5 103.399 103.399 132.5 67.5 132.5 C 31.6015 132.5 2.5 103.399 2.5 67.5 C 2.5 31.6015 31.6015 2.5 67.5 2.5 C 103.399 2.5 132.5 31.6015 132.5 67.5 Z"
        stroke-linecap="round" />
    </g>
  </svg>
</template>

<script lang="ts">
import BaseComponent from '@/components/Base.vue';
import { defineComponent } from "vue";

export default defineComponent({
  extends: BaseComponent,
});
</script>